import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionModelService, MachineFamillyService } from '../../services/index';
import { Inspection } from '../../models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

@Component({
    selector: 'import-section-index-page',
    templateUrl: './index.component.html',
    standalone: false
})
export class ImportSectionIndexPageComponent extends BaseModalPageComponent implements OnInit {
  inspections: Inspection[];
  targetId: string;
  selectedInspection: Inspection;
  errorMessage: string;
  navigationRoute: string;

  public loading: Boolean = true;

  constructor(
    public inspectionModelService: InspectionModelService,
    private machineFamillyService: MachineFamillyService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.navigationRoute = this.router.url.includes('inspections') ? this.inspectionsRoute : this.templatesRoute;
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const targetId = params['targetId'];
      if (targetId == null) this.router.navigate([this.navigationRoute]);

      this.targetId = targetId;
      this.initData();
    });
  }

  selectInspection(inspection: Inspection): void {
    this.selectedInspection = inspection;
  }

  openInspection(): void {
    this.router.navigate([this.navigationRoute, this.targetId, 'addsection', this.selectedInspection.id]);
  }

  cancel() {
    this.goToBack();
  }

  initData(): void {
    this.machineFamillyService.getCurrentScopeProductLines().subscribe((pr) => {
      const productLines = pr.map((p) => p.id);
      this.inspectionModelService.getModels().subscribe((data) => {
        this.inspections = data.filter((d) => d.categories.some((c) => productLines.includes(c.ProductLineId)));
        this.loading = false;
      });
    });
  }
}
